import React, { Component } from "react";
import { useState, useEffect } from 'react'
import store from "@/redux/store";

import { MagnifyingGlassIcon, QuestionMarkCircleIcon } from '@heroicons/react/20/solid'
import {
  Bars3Icon,
  BellIcon,
  CogIcon,
  CreditCardIcon,
  KeyIcon,
  SquaresPlusIcon,
  UserCircleIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline'


import { BuildingOfficeIcon, UserIcon, UsersIcon } from '@heroicons/react/20/solid'

import { Company } from "@/views/Settings/Company";
import { Invoice } from "@/views/Settings/Invoice";
import { Interest } from "@/views/base/user/Interest";
import {getUserInterests} from "@/reducers/User";

import {WorkTypeSettingsView} from '@/views/Settings/BaseSettings/WorkType';
import {VatRateSettingsView} from '@/views/Settings/BaseSettings/VatRate';
import { ContactTypeView } from "./BaseSettings/ContactTypes";
import { WorkhoursSettingsView } from "./BaseSettings/Workhours";

export function BaseSettings({...props}) {
    const [selectedTab, setSelectedTab] = useState(1)

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const subNavigation = [


  {id: 1, name: 'Werk types', href: '#', icon: CogIcon, current: true },
  {id: 2, name: 'BTW tarieven', href: '#', icon: CogIcon, current: false },
  {id: 3, name: 'Contact types', href: '#', icon: CogIcon, current: false },
  {id: 4, name: 'Werkuren', href: '#', icon: CogIcon, current: false },
]

const handlerSelectedTab =(event, selectedTab) => {
    
    
    
    setSelectedTab(selectedTab.id);
    
    //return false;
}


     return (
        <>
        
       <main className="mx-auto max-w-10xl pb-10 lg:px-2 lg:py-12">
          <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
            <aside className="px-2 py-6 sm:px-6 lg:col-span-3 lg:px-0 lg:py-0">
              <nav className="space-y-1">
                {subNavigation.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    onClick={() => handlerSelectedTab(event, item)}
                    aria-current={item.id == selectedTab ? 'page' : undefined}
                    className={classNames(
                      item.id == selectedTab
                        ? 'bg-gray-50 text-orange-600 hover:bg-white'
                        : 'text-gray-900 hover:bg-gray-50 hover:text-gray-900',
                      'group flex items-center rounded-md px-3 py-2 text-sm font-medium',
                    )}
                  >
                    <item.icon
                      aria-hidden="true"
                      className={classNames(
                        item.id == selectedTab ? 'text-orange-500' : 'text-gray-400 group-hover:text-gray-500',
                        '-ml-1 mr-3 h-6 w-6 flex-shrink-0',
                      )}
                    />
                    <span className="truncate">{item.name}</span>
                  </a>
                ))}
              </nav>
            </aside>
            
            
            

            {/* Payment details */}
            <div className="space-y-6 sm:px-6 lg:col-span-9 lg:px-0">
              <section aria-labelledby="payment-details-heading"
                      className={classNames(
                        2 == selectedTab ? '' : 'hidden',
                        '',
                      )}
                >
                <VatRateSettingsView {...props} key={props.SettingsReducer.key} />
              </section>
              
              <section aria-labelledby="payment-details-heading"
                      className={classNames(
                        1 == selectedTab ? '' : 'hidden',
                        '',
                      )} >
                      <WorkTypeSettingsView {...props} key={props.SettingsReducer.key}/>
              </section>
              
              <section aria-labelledby="payment-details-heading"
                      className={classNames(
                        3 == selectedTab ? '' : 'hidden',
                        '',
                      )} >
                      <ContactTypeView {...props} key={props.SettingsReducer.key}/>
              </section>

                            <section aria-labelledby="payment-details-heading"
                      className={classNames(
                        4 == selectedTab ? '' : 'hidden',
                        '',
                      )} >
                      <WorkhoursSettingsView {...props} key={props.SettingsReducer.key}/>
              </section>
              
              
              
        </div>            
 </div>           
            
            
            </main>
        
        
        </>     
    );
}